import thunk from 'redux-thunk';
import serverVars from 'server-vars';
import { initializePrerenderedCheckout } from 'dibs-checkout/exports/prerender/initializePrerenderedCheckout';
import { getItemIdFromUri } from '../../utils/getItemIdFormUri';

/* Queries */
import { pdpRespCondensedRootQuery } from '../../queries/pdpRespCondensedRoot';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils';
import { pdpRespSimilarItemsReducer as similarItems } from '../../reducers/pdpRespSimilarItemsReducer';
import { pdpRespMakeOfferModalReducer as makeOfferModal } from '../../reducers/pdpRespMakeOfferModalReducer';

/* Components */
import { PdpRespCondensedLayout } from '../../pdp/PdpRespCondensedLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import { initSharedDatadogRum, pdpTypes } from 'dibs-buyer-layout/exports/initSharedDatadogRum';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    middleware: [thunk],
    reducers: {
        similarItems,
        makeOfferModal,
        ...defaultReducers,
    },
};

const itemId = getItemIdFromUri(window.location.pathname);

initSharedDatadogRum({ page: PAGE_TYPE.PDP, pageType: pdpTypes.condensed, device: 'resp' });

initializeDBL(options).then(async ({ store }) => {
    createEntry({
        Container: PdpRespCondensedLayout,
        store,
        query: pdpRespCondensedRootQuery,
    });

    const locale = serverVars.get('locale');
    const messages = serverVars.get('messages');

    if (itemId) {
        await initializePrerenderedCheckout({
            isMobile: false,
            itemId,
            locale,
            messages,
        });
    }
});
